import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { theme } from '@/theme';

export const StyledWrapper = styled('div')`
    display: flex;
    min-height: 100vh;
    height: 100%;
    width: 100%;
    min-width: 0;
    background-color: ${theme.palette.background.default};

    .snackbarContainer {
        box-shadow: initial;
        margin-top: 10rem;
        margin-bottom: initial;
        box-sizing: inherit;
    }

    .snackbarBody {
        background: transparent;
        min-height: 0;
        padding: 0 1rem;
        border-radius: 0.4rem;
        box-sizing: inherit;
        box-shadow: none;
    }
`;

export const StyledContainer = styled('div')<{ fullpage: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 0;
    min-height: 100%;
    padding: ${({ fullpage }) => (fullpage ? '0' : '20px 16px 0 20px')};

    ${theme.breakpoints.up('sm')} {
        flex-grow: 1;
    }
`;

export const StyledHeading = styled('div')``;

export const StyledContent = styled('div')<{ fullpage: boolean }>`
    justify-self: center;
    position: relative;
    width: 100%;
    min-width: 0;

    ${({ fullpage }) =>
        fullpage &&
        css`
            display: grid;
            grid-template-rows: 1fr;
            grid-gap: 2rem;
            height: 100%;
            padding: 0;
            max-width: 100vw;
        `}
`;

export const StyledSpacing = styled('div')`
    flex: 1;
`;

export const StyledFooter = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: 1.677rem;
    padding-bottom: 1.333rem;
    font-size: 1rem;
    font-weight: lighter;
    color: ${theme.palette.muted.muted4};
`;
